import type { UserRole } from '@/api/generated/model';

// Роли вложены: администратор умеет всё, что менеджер; менеджер — всё, что кладовщик.
// Названия ролей — в словаре: roles.storekeeper / roles.manager / roles.admin.
const RANK: Record<UserRole, number> = { storekeeper: 1, manager: 2, admin: 3 };

export function hasRole(role: UserRole, min: UserRole): boolean {
  return RANK[role] >= RANK[min];
}
